import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/vivek-malla',
    label: 'Github',
    icon: faGithub,
  },

  {
    link: 'https://www.instagram.com/thisisvivekmalla_official/',
    label: 'Instagram',
    icon: faInstagram,
  },
  {
    link: 'https://www.linkedin.com/in/vivekmalla',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'https://twitter.com/vivekmallatwt',
    label: 'Twitter',
    icon: faTwitter,
  },
  {
    link: 'mailto:vivekmalla4158@gmail.com',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
